import { T_GenerateTokenRes } from "../features/Feature_Login/Login_Types";
import { T_CustomerLobDetails, T_UserProfile } from "../globalTypes/GlobalTypes";
import { EVENT_HANDLER } from "./constants";
import { E_ChannelOptions } from "./conversionUtils";
import { getMobileOperatingSystem, getModuleNameFromPath, goToSuperAppInfo } from "./helper";
import { downloadPDFFromBase64 } from "./NativeAppEvents";


function browserDownload(
    base64: string,
    contentType: string,
    fileName: string
) {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const blob = new Blob(
        [new Uint8Array(byteNumbers)],
        {
            type:
                contentType === "PDF"
                    ? "application/pdf"
                    : "application/octet-stream",
        }
    );

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

export function initTwaDownloadListener(
    csAppSlice: any,
    dispatch: any,
    downloadDocumentCode: string
) {
    const handler: EventListener = (event) => {
        const messageEvent = event as MessageEvent;

        let data: any;
        try {
            data =
                typeof messageEvent.data === "string"
                    ? JSON.parse(messageEvent.data)
                    : messageEvent.data;
        } catch {
            return;
        }

        if (data?.action !== "DownloadDocument") return;

        const {
            base64Content: pdfData,
            contentType,
            fileName = "document.pdf",
        } = data.payload || {};

        if (!pdfData) return;

        // ----------------------------
        // SUPER APP
        // ----------------------------
        if (csAppSlice.channel === E_ChannelOptions.SUPER_APP) {
            let superAppData: any = goToSuperAppInfo(
                csAppSlice?.tokenDetails as T_GenerateTokenRes,
                csAppSlice?.userDetails as T_UserProfile & T_CustomerLobDetails,
                downloadDocumentCode
            );

            superAppData.supportingData.base64Content = pdfData;
            superAppData.supportingData.contentType =
                fileName?.slice(-4)?.toLowerCase() === ".pdf" ? "PDF" : "Excel";

            console.log("EventName : " + EVENT_HANDLER.DOWNLOAD_DOCUMENT, superAppData);

            dispatch({
                type: EVENT_HANDLER.DOWNLOAD_DOCUMENT,
                payload: superAppData,
            });
            return;
        }

        // ----------------------------
        // iOS Native
        // ----------------------------
        if (getMobileOperatingSystem() === "iOS" && csAppSlice.NativeDeviceInfo?.deviceName) {
            downloadPDFFromBase64({
                type: "downloadPDFFromBase64",
                base64: pdfData,
                fileName,
            })
            return;
        }

        // ----------------------------
        // Android WebView
        // ----------------------------
        if (getMobileOperatingSystem() === "Android" && csAppSlice.NativeDeviceInfo?.deviceName) {
            const message = {
                action: "DOWNLOAD_PDF",
                payload: "Event from web app",
                pdfData,
                fileName,
            };
            if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(JSON.stringify(message));
                console.log(
                    "Sending event to TWA React Native Android " + JSON.stringify(message)
                );
            }
            return;
        }

        // ----------------------------
        // Default Web / PWA
        // ----------------------------
        browserDownload(pdfData, contentType, fileName);
    };

    window.addEventListener("message", handler);

    return () => {
        window.removeEventListener("message", handler);
    };
}